import React from 'react';
import './ModalError.css';

const ModalError = ({ show, error, onClose }) => {
  if (!show || !error) return null;

  return (
    <div className="modal-error-overlay">
      <div className="modal-error-content">
        <div className="modal-error-header">
          <h6>
            <i className="fas fa-exclamation-triangle"></i>
            Erro de Validação
          </h6>
          <button 
            type="button" 
            className="btn-close-modal-error"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-error-body">
          <p>{error}</p>
        </div>
        <div className="modal-error-footer">
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={onClose}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalError;